import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import * as alertify from 'alertifyjs';
import { Location } from '@angular/common';

@Component({
  selector: 'app-query-modal',
  templateUrl: './query-modal.component.html',
  styleUrls: ['./query-modal.component.css']
})
export class QueryModalComponent {

  @Output() onConfirmClicked = new EventEmitter();
  @Input() body = 'Are you sure you want to perform this action?';
  @Input() dismissOnConfirm = true;
  @Input() showCancel = true;
  @Input() showLoadingOnConfirmClick = true;
  @Input() loading = false;
  @Input() assessmentId: any;
  @Input() assessmentClass: any;
  @Input() type: any;

  form: FormGroup;

  constructor(
    public modalRef: BsModalRef,
    private bsModalService: BsModalService,
    private fb: FormBuilder,
    private apiService: ApiServiceService,
    private location: Location,
  ) {
    this.form = this.fb.group({
      reason: [''],
      assessmentId: [''],
      assessmentClass: [''],
      type: ['']
    });
  }

 

  confirm() {
    if (this.showLoadingOnConfirmClick) {
      this.loading = true;
    }
    this.onConfirm();
    this.onConfirmClicked.emit();
    if (this.dismissOnConfirm) {
      this.modalRef.hide();
    }
  }

  goBack() {
    this.location.back();
  }

  query(){

    if(this.assessmentClass == 'annualReturn'){

      const url = "/assessments/annualReturn/approve"
    let pojo = {
      approval: 'QUERIED',
      id: this.assessmentId,
      query: this.form.get('reason').value,
      reason: this.form.get('reason').value,
      comment: this.form.get('reason').value
    }
    this.apiService.post(url, pojo).subscribe(
      (response) => {
        
        alertify.set("notifier", "position", "top-center");
        alertify.success("Annual Return Queried Successfully");

        this.confirm();
        this.goBack();
        
      },
      (error) => {
       
        this.errorConfirm()
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        
      }
    );
    }else{

    let url = "/assessments/query"
    this.form.patchValue({'assessmentId': this.assessmentId});
    this.form.patchValue({'assessmentClass': this.assessmentClass});
    this.form.patchValue({'type': this.type});

    this.apiService.post(url, this.form.value).subscribe(
      (response) => {
        
        alertify.set("notifier", "position", "top-center");
        alertify.success("Assessment queried successfully");
        this.confirm();
        this.close();
        
      },
      (error) => {
       
        this.errorConfirm()
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        
      }
    );

    }
  }

  onConfirm: any = () => {
  };

  close() {
    this.modalRef.hide();
    setTimeout(function () {
      window.location.reload();
    }, 500);
  }


  errorConfirm(){
    let bsModalRef = this.bsModalService.show(ErrorDialogComponent, {
      class: 'modal-sm modal-dialog-centered',
      ignoreBackdropClick: true,
    });
    bsModalRef?.content?.onConfirmClicked.subscribe(v => {
      bsModalRef.hide();
    });
  }

}
